<template>
  <div v-if="!start" class="menu-section">
    <div
      class="content"
      @mouseover="mostrar"
      @mouseleave="ocultar"
      :class="{ noExpand: !isExpanded }"
    >
      <div class="item" @click="toogleFundo">
        <transition name="slide">
          <div class="text" v-if="isExpanded">
            <span v-if="!sound">Ligar música de fundo</span
            ><span v-else>Desligar música de fundo</span>
          </div>
        </transition>
        <div v-if="sound" class="icon">
          <i class="size2 bi bi-volume-up"></i>
        </div>
        <div v-else class="icon"><i class="size2 bi bi-volume-mute"></i></div>
      </div>
      <div class="item" @click="goToN3">
        <transition name="slide">
          <div class="text" v-if="isExpanded">A política do negacionismo</div>
        </transition>
        <div class="icon">
          <img class="ball" src="@/assets/images/ball3.png" alt="" />
        </div>
      </div>
      <div class="item" @click="goToN2">
        <transition name="slide">
          <div class="text" v-if="isExpanded">Cartas de amor e despedida</div>
        </transition>
        <div class="icon">
          <img class="ball" src="@/assets/images/ball2.png" alt="" />
        </div>
      </div>
      <div class="item" @click="goToN1">
        <transition name="slide">
          <div class="text" v-if="isExpanded">
            Coronavírus não é Habeas Corpus
          </div>
        </transition>
        <div class="icon">
          <img class="ball" src="@/assets/images/ball1.png" alt="" />
        </div>
      </div>
      <div class="item" @click="goToSiglas">
        <transition name="slide">
          <div class="text" v-if="isExpanded">Siglas e resoluções</div>
        </transition>
        <div class="icon"><i class="bi bi-sticky"></i></div>
      </div>
      <div class="item" @click="voltarAoTopo">
        <transition name="slide">
          <div class="text" v-if="isExpanded">Voltar para o topo</div>
        </transition>
        <div class="icon no-b"><i class="bi bi-chevron-double-up"></i></div>
      </div>
    </div>
  </div>
</template>

<script>
import scrollTo from "@degjs/scroll-to";
export default {
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    sound() {
      return this.$store.state.soundFundo;
    },
    start() {
      return this.$store.state.start;
    },
  },
  methods: {
    mostrar() {
      this.isExpanded = true;
    },
    toogleFundo() {
      if (this.sound) this.desligarSom();
      else this.ligarSom();
    },
    ligarSom() {
      this.$store.commit("ligarFundo");
    },
    desligarSom() {
      this.$store.commit("desligarFundo");
    },
    ocultar() {
      this.isExpanded = false;
    },
    voltarAoTopo() {
      let destinationElement = document.getElementById("initialSection");
      scrollTo({
        element: destinationElement,
        duration: 100,
        easing: "easeInOut",
      });
    },
    goToN3() {
      let destinationElement = document.getElementById("n3Section");
      scrollTo({
        element: destinationElement,
        duration: 100,
        easing: "easeInOut",
      });
    },
    goToN2() {
      let destinationElement = document.getElementById("n2Section");
      scrollTo({
        element: destinationElement,
        duration: 100,
        easing: "easeInOut",
      });
    },
    goToN1() {
      let destinationElement = document.getElementById("n1Section");
      scrollTo({
        element: destinationElement,
        duration: 100,
        easing: "easeInOut",
      });
    },
    goToSiglas() {
      let destinationElement = document.getElementById("siglasSection");
      scrollTo({
        element: destinationElement,
        duration: 100,
        easing: "easeInOut",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.size2 {
  font-size: 1.3rem;
}
.menu-section {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  .content {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 5px;
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1;
    display: flex;
    flex-direction: column;
    color: #626262;
    padding: 20px 5px;

    &.noExpand {
      background: transparent;
    }
  }
  .item {
    display: flex;
    cursor: pointer;

    .text {
      width: 130px;
      text-align: right;
    }

    .icon {
      margin-left: 15px;
      margin-bottom: 25px;
      width: 30px;

      .ball {
        width: 18px;
      }

      &.no-b {
        margin-bottom: 0;
      }
    }
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(10px);
  opacity: 0;
  transition: all 150ms ease-in 0s;
}

@media screen and (max-width: 480px) {
  .menu-section {
    position: fixed;
    right: -9px;
    transform: scale(0.9);

    .content {
      background-color: white;
    }
  }
}
</style>